export enum ErrorWarningValidationType {
  Error = 'error',
  Warning = 'warning',
}
